<template>
    <div class="min-h-screen bg-gray-50">
        <Header />
        <div class="container mx-auto py-6 pb-16">
            <div class="flex flex-col lg:flex-row gap-8">
                <div class="product-detail w-full">
                    <nav class="breadcrumb">
                        <router-link to="/">首页</router-link><span>/</span>
                        <router-link to="/product">数字产品</router-link><span>/</span>
                        <router-link v-if="product" to="/product">{{ getDictLabelByValue(product.category) }}</router-link><span v-if="product">/</span>
                        <span>{{ product ? product.name : '产品详情' }}</span>
                    </nav>

                    <div v-if="product" class="detail-main">
                        <div class="card">
                            <div class="product-top">
                                <div class="product-image">
                                    <img v-if="product.imageUrl" :src="getFullImageUrl(product.imageUrl)" :alt="product.name">
                                    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                                </div>
                                <div class="product-info">
                                    <h1 class="product-name">{{ product.name }}</h1>
                                    <div class="product-tags">
                                        <span>{{ getDictLabelByValue(product.category) }}</span>
                                        <span>{{ getDictLabelByValue(product.domain) }}</span>
                                    </div>
                                    <p class="product-desc-short">{{ product.description }}</p>
                                    <div class="product-meta-row"><strong>供应商：</strong>{{ product && product.companyName ? product.companyName : "暂无" }}</div>
                                    <div class="product-meta-row"><strong>所属领域：</strong>{{ product && getDictLabelByValue(product.category) ? getDictLabelByValue(product.category) : "-" }} / {{ product && getDictLabelByValue(product.domain) ? getDictLabelByValue(product.domain) : "-" }}</div>
                                </div>
                            </div>
                        </div>

<!--                        <div class="card price-card">-->
<!--                            <div class="card-title">价格信息</div>-->
<!--                            <div class="price-block">-->
<!--                                <div v-if="product.discount" class="discount-highlight">{{ discountText(product.discount) }}</div>-->
<!--                                <div v-if="product.discount" class="price-original-box">-->
<!--                                    <div class="label">原价</div>-->
<!--                                    <div class="price-original">&yen;{{ product.price }}元</div>-->
<!--                                </div>-->
<!--                                <div class="member-price-box">-->
<!--                                    <div class="label">{{ product.discount ? '会员价' : '价格' }}</div>-->
<!--                                    <div class="member-price"><small>&yen;</small>{{ product.discount ? product.memberPrice : product.price }}元<span v-if="product.priceUnit" class="price-unit">/{{ getSubscriptionPeriodByValue(product.priceUnit) }}</span></div>-->
<!--                                    <div v-if="product.discount" class="member-note">会员享{{ discountText(product.discount) }}优惠</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="price-actions">-->
<!--                                <button class="btn-primary" type="button">立即咨询</button>-->
<!--&lt;!&ndash;                                <button class="btn-secondary" type="button" @click="$router.back()">返回列表</button>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="card price-card">
                            <!-- 顶部装饰条 -->
<!--                            <div class="card-accent"></div>-->

                            <!-- 标题行 -->
<!--                            <div class="card-title">-->
<!--                                <svg class="title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">-->
<!--                                    <circle cx="12" cy="12" r="10"/>-->
<!--                                    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>-->
<!--                                    <path d="M12 18V6"/>-->
<!--                                </svg>-->

<!--                            </div>-->
                            <div class="card-title">价格信息</div>
                            <!-- 价格主体 -->
                            <div class="price-block">
                                <!-- 折扣角标 -->
                                <div v-if="product.discount" class="discount-badge">
                                    <span class="badge-pulse"></span>
                                    {{ discountText(product.discount) }}
                                </div>
                                <!-- 原价行 -->
                                <div v-if="product.discount" class="price-original-row">
                                    <span class="label">原价</span>
                                    <span class="price-original">&yen;{{ product.price }}元</span>
                                </div>
                                <!-- 会员价 / 主价格 -->
                                <div class="member-price-row">
                                    <div class="label-wrap">
                                        <span class="label">{{ product.discount ? '会员价' : '价格' }}</span>
                                        <span v-if="product.discount" class="label-tag">限时</span>
                                    </div>
                                    <div class="member-price">
                                        <span class="currency">&yen;</span>
                                        <span class="amount">{{ product.discount ? product.memberPrice : product.price }}</span>
                                        <span class="suffix">元</span>
                                        <span v-if="product.priceUnit" class="price-unit">/{{ getSubscriptionPeriodByValue(product.priceUnit) }}</span>
                                    </div>
                                    <div v-if="product.discount" class="member-note">
                                        <svg class="note-icon" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                        </svg>
                                        会员享{{ discountText(product.discount) }}优惠
                                    </div>
                                </div>
                            </div>

                            <!-- 按钮区 -->
                            <div class="price-actions">

                                <button class="btn-primary" type="button">
                                    <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                                    </svg>
                                    立即咨询
                                </button>
<!--                                <button class="btn-secondary" type="button" @click="$router.back()">-->
<!--                                    <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">-->
<!--                                        <path d="M19 12H5M12 19l-7-7 7-7"/>-->
<!--                                    </svg>-->
<!--                                    返回列表-->
<!--                                </button>-->
                            </div>
                        </div>


                        <div class="card">
                            <div class="card-title">产品配置</div>
                            <div class="desc-text">{{ product.config }}</div>
                        </div>

                        <div class="card">
                            <div class="card-title">产品描述</div>
                            <div class="desc-text">{{ product.description }}</div>
                        </div>

                        <div class="card">
                            <div class="card-title">供应商信息</div>
                            <div class="supplier-info">
                                <div class="supplier-avatar">{{ product && product.companyName ? product.companyName.slice(0, 1) : "" }}</div>
                                <div>
                                    <div class="supplier-name">{{ product && product.companyName ? product.companyName : "暂无供应商" }}</div>
                                    <div class="supplier-desc">优质供应商，产品已入驻数字产品超市</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="not-found">
                        <h2>产品不存在</h2>
                        <p>未找到该产品信息，请返回列表页浏览</p>
                        <router-link to="/product" class="btn-primary">返回产品列表</router-link>
                    </div>
                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import {CURRENT_CONFIG} from "@/api/config";
import Header from '../components/Header.vue'
import AppFooter from '../components/Footer.vue'
import {api} from "@/api";
export default {
    name: 'ProductDetail.vue',
    components: {
        Header,
        AppFooter
    },
    data() {
        return {
            loading: false,
            BASE_URL: CURRENT_CONFIG.BASE_URL,
            product: {},
            productId: null,
            dictList: [],
            biz_subscription_period_type: []
        }
    },
    computed: {
    },
    mounted() {
        // 从路由参数中获取产品ID
        this.productId = this.$route.params.id;
        this.getDataBizSubscriptionPeriodType()
        // 先获取字典数据，再获取产品详情
        this.getDataDictList().then(() => {
            this.getProductDetail()
        });
    },
    methods: {
        price(value) {
            return value.toLocaleString()
        },
        discountText(value) {
            return `${Number(value).toFixed(1).replace(/\.0$/, '')}折`
        },
        // 根据字典值获取对应的标签文字
        getDictLabelByValue(value) {
            if (!value) return '';
            const dictItem = this.dictList.find(item => item.dictValue === value);
            return dictItem ? dictItem.dictLabel : value;
        },
        getSubscriptionPeriodByValue(value) {
            if (!value) return '';
            const dictItem = this.biz_subscription_period_type.find(item => item.dictValue === value);
            return dictItem ? dictItem.dictLabel : value;
        },
        async getProductDetail() {
            this.product = {}
            const result = await api.getProductDetailApi(this.productId)
            if (result.code === 200) {
                this.product = result.data
            }
        },
        // 获取数据字典
        async getDataDictList() {
            this.dictList = [];
            const dictType = 'biz_digital_product_type';
            const result = await api.getDataDictApi(dictType);
            if (result.code === 200) {
                this.dictList = result.rows;
            }
        },
        async getDataBizSubscriptionPeriodType() {
            this.biz_subscription_period_type = []
            const dictType = 'biz_subscription_period_type'
            const result = await api.getDataDictApi(dictType)
            if (result.code === 200) {
                this.biz_subscription_period_type = result.rows
            }
        },
        getFullImageUrl(path) {
            return this.BASE_URL + path
        },
    }
}
</script>
<style scoped>
.product-detail { color: #333; }
.breadcrumb { display: flex; align-items: center; max-width: none; margin: 0 0 24px; padding: 12px 16px; background: #fff; border-radius: 8px; box-shadow: 0 1px 4px rgba(0,0,0,.04); font-size: 13px; color: #999; }
.breadcrumb a { color: #2d6bc4; text-decoration: none; }
.breadcrumb a:hover { text-decoration: underline; }
.breadcrumb span { margin: 0 6px; }
.detail-main { max-width: 1100px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px; }
.card { background: #fff; border-radius: 12px; padding: 28px; box-shadow: 0 2px 12px rgba(0,0,0,.06); }
.card-title { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 2px solid #f0f0f0; position: relative; }
.card-title::after { content: ''; position: absolute; bottom: -2px; left: 0; width: 40px; height: 2px; background: #2d6bc4; }
.product-top { display: flex; gap: 28px; }
.product-image { width: 320px; height: 240px; flex-shrink: 0; background: linear-gradient(135deg, #e8f0fe, #d4e4fc); border-radius: 12px; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.product-image img { max-height: 100%; max-width: 100%; object-fit: cover; width: auto; }
.product-image svg { width: 100px; height: 100px; color: #aac; }
.product-info { flex: 1; display: flex; flex-direction: column; }
.product-name { font-size: 22px; font-weight: 700; color: #1a1a2e; margin-bottom: 12px; }
.product-tags { display: flex; gap: 8px; margin-bottom: 16px; flex-wrap: wrap; }
.product-tags span { padding: 4px 14px; background: #f0f5ff; color: #2d6bc4; border-radius: 4px; font-size: 13px; font-weight: 500; }
.product-desc-short { font-size: 14px; color: #666; margin-bottom: 20px; line-height: 1.8; flex: 1; }
.product-meta-row { display: flex; gap: 4px; font-size: 13px; color: #999; margin-bottom: 8px; }
.product-meta-row strong { color: #666; }
.price-block { display: flex; flex-direction: column; gap: 12px; }
.label { font-size: 13px; color: #999; }
.price-original-box, .member-price-box { display: flex; flex-direction: column; }
.price-original { font-size: 18px; color: #bbb; text-decoration: line-through; }
.discount-highlight { display: inline-flex; align-items: center; justify-content: center; background: #e6453a; color: #fff; padding: 6px 14px; border-radius: 20px; font-size: 14px; font-weight: 600; margin-bottom: 4px; }
.member-price { font-size: 36px; font-weight: 700; color: #e6453a; line-height: 1; }
.member-price small { font-size: 16px; font-weight: 400; }
.price-unit { font-size: 14px; font-weight: 400; color: #999; }
.price-unit-note { font-size: 13px; color: #666; margin-top: 6px; }
.member-note { font-size: 12px; color: #2d6bc4; margin-top: 4px; }
.price-actions { display: flex; gap: 12px; margin-top: 16px; }
.btn-primary { padding: 10px 32px; background: #2d6bc4; color: #fff; border: 0; border-radius: 8px; font-size: 15px; cursor: pointer; transition: background .3s; text-decoration: none; display: inline-block; }
.btn-primary:hover { background: #1a3a6b; }
.btn-secondary { padding: 10px 32px; background: #fff; color: #2d6bc4; border: 1px solid #2d6bc4; border-radius: 8px; font-size: 15px; cursor: pointer; transition: all .3s; }
.btn-secondary:hover { background: #f5f8ff; }
.desc-text { font-size: 14px; color: #666; line-height: 2; white-space: pre-wrap; }
.supplier-info { display: flex; align-items: center; gap: 16px; }
.supplier-avatar { width: 56px; height: 56px; background: #f0f5ff; border-radius: 12px; display: flex; align-items: center; justify-content: center; color: #2d6bc4; font-weight: 700; font-size: 20px; }
.supplier-name { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 4px; }
.supplier-desc { font-size: 13px; color: #999; }
.not-found { text-align: center; padding: 80px 20px; background: #fff; border-radius: 12px; }
.not-found h2 { font-size: 24px; color: #999; margin-bottom: 16px; }
.not-found p { color: #999; margin-bottom: 20px; }
@media (max-width: 640px) { .product-top { flex-direction: column; } .product-image { width: 100%; height: 200px; } .price-actions { flex-direction: column; } }


/* ============ 价格卡片样式 ============ */
.price-card {
    width: 100%;
    position: relative;
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow:
        0 1px 3px rgba(0, 0, 0, 0.04),
        0 6px 24px rgba(0, 0, 0, 0.06),
        0 0 0 1px rgba(0, 0, 0, 0.03);
    transition: box-shadow 0.35s ease, transform 0.35s ease;
}

.price-card:hover {
    box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.06),
        0 12px 40px rgba(0, 0, 0, 0.1),
        0 0 0 1px rgba(0, 0, 0, 0.04);
    transform: translateY(-2px);
}

/* 顶部装饰条 */
.card-accent {
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    border-radius: 0 0 2px 2px;
}

/* 标题 */
/*.card-title {*/
/*    display: flex;*/
/*    align-items: center;*/
/*    gap: 8px;*/
/*    padding: 20px 24px 0;*/
/*    font-size: 17px;*/
/*    font-weight: 700;*/
/*    color: #1a1a2e;*/
/*    letter-spacing: 0.3px;*/
/*}*/

.title-icon {
    width: 20px;
    height: 20px;
    color: #667eea;
    flex-shrink: 0;
}

/* 价格主体 */
.price-block {
    padding: 16px 24px 20px;
    position: relative;
}

/* 折扣角标 - 浮动在右上 */
.discount-badge {
    position: absolute;
    top: 10px;
    left: 150px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    border-radius: 20px;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 14px rgba(238, 90, 36, 0.35);
    animation: badgeBounce 2s ease-in-out infinite;
}

.badge-pulse {
    display: inline-block;
    width: 7px;
    height: 7px;
    background: #fff;
    border-radius: 50%;
    animation: pulseDot 1.5s ease-in-out infinite;
}

@keyframes badgeBounce {
    0%,
    100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-3px);
    }
}

@keyframes pulseDot {
    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.5;
        transform: scale(1.8);
    }
}

/* 原价行 */
.price-original-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    position: relative;
}

.price-original-row .label {
    font-size: 13px;
    color: #999;
    font-weight: 500;
    min-width: 32px;
}

.price-original {
    font-size: 15px;
    color: #b0b0b0;
    text-decoration: line-through;
    text-decoration-color: #d0d0d0;
    text-decoration-thickness: 1.5px;
    font-weight: 500;
}

/* 会员价行 */
.member-price-row {
    background: linear-gradient(135deg, #fdfcfb 0%, #f7f4f9 100%);
    border-radius: 12px;
    padding: 16px 18px;
    border: 1px dashed #e2d8f0;
    position: relative;
    width: 42%;
}

.label-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.label-wrap .label {
    font-size: 13px;
    color: #7c6fa0;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.label-tag {
    font-size: 11px;
    padding: 2px 8px;
    background: #667eea;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    animation: tagGlow 2.5s ease-in-out infinite;
}

@keyframes tagGlow {
    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(102, 126, 234, 0);
    }
}

.member-price {
    display: flex;
    align-items: baseline;
    gap: 2px;
    margin-bottom: 6px;
}

.currency {
    font-size: 18px;
    font-weight: 700;
    color: #5b4a8a;
    align-self: flex-start;
    margin-top: 4px;
}

.amount {
    font-size: 38px;
    font-weight: 800;
    color: #3d2c6b;
    line-height: 1;
    letter-spacing: -1px;
}

.suffix {
    font-size: 16px;
    font-weight: 600;
    color: #5b4a8a;
    align-self: flex-end;
    margin-bottom: 4px;
}

.price-unit {
    font-size: 14px;
    color: #8b7daf;
    font-weight: 500;
    align-self: flex-end;
    margin-bottom: 3px;
    margin-left: 2px;
}

/* 优惠说明 */
.member-note {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #8b7daf;
    font-weight: 500;
}

.note-icon {
    width: 14px;
    height: 14px;
    color: #4ecb71;
    flex-shrink: 0;
}

/* 按钮区 */
.price-actions {
    display: flex;
    gap: 10px;
    padding: 0 24px 22px;
    width: 45%;
}

.btn-primary,
.btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 20px;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;
    letter-spacing: 0.3px;
    white-space: nowrap;
}

.btn-primary {
    flex: 1;
    background: linear-gradient(135deg, #667eea 0%, #5a67d8 100%);
    color: #fff;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.35);
}

.btn-primary:hover {
    background: linear-gradient(135deg, #5a67d8 0%, #4c51bf 100%);
    box-shadow: 0 6px 22px rgba(102, 126, 234, 0.5);
    transform: translateY(-1px);
}

.btn-primary:active {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
    flex: 1;
    background: #f5f3f9;
    color: #5b4a8a;
    min-width: 100px;
}

.btn-secondary:hover {
    background: #ebe6f5;
    transform: translateY(-1px);
}

.btn-secondary:active {
    transform: translateY(0) scale(0.98);
    background: #e0d8ed;
}

.btn-icon {
    width: 17px;
    height: 17px;
    flex-shrink: 0;
}

/* 响应式微调 */
@media (max-width: 400px) {
    .card-title {
        padding: 16px 16px 0;
    }
    .price-block {
        padding: 12px 16px 16px;
    }
    .price-actions {
        padding: 0 16px 18px;
        flex-direction: column;
    }
    .btn-secondary {
        min-width: unset;
    }
    .amount {
        font-size: 30px;
    }
    .discount-badge {
        right: 8px;
        font-size: 12px;
        padding: 5px 10px;
    }
}
</style>
